import e from "./getPrototypeOf.js";
import n from "./isNativeReflectConstruct.js";
import a from "./possibleConstructorReturn.js";
function l(o) {
  var s = n();
  return function() {
    var r = e(o), t;
    if (s) {
      var u = e(this).constructor;
      t = Reflect.construct(r, arguments, u);
    } else
      t = r.apply(this, arguments);
    return a(this, t);
  };
}
export {
  l as default
};
//# sourceMappingURL=createSuper.js.map
